import classNames from 'classnames';
import { IconRenderer } from "../../../helper/components/IconRenderer.js";
import styles from "./ButtonIconLayout.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ButtonIconLayout({
  icon,
  iconPlacement = 'LEADING',
  children
}) {
  return /*#__PURE__*/_jsxs("span", {
    className: classNames(styles.buttonIconLayout, styles[iconPlacement]),
    children: [/*#__PURE__*/_jsx(IconRenderer, {
      icon: icon
    }), /*#__PURE__*/_jsx("span", {
      children: children
    })]
  });
}